<h1 class="section-header-font coming-soon">Feedback</h1>

<avia-modal-fullscreen #feedbackmodal>
  <app-feedback-form [templateloader]="getFeedbackFormTemplateLoader" [previousUrl]='previousUrl' (cancel)="done(); feedbackmodal.close();" (submit)="done(); feedbackmodal.close();"></app-feedback-form>
</avia-modal-fullscreen>
